import { create } from 'zustand';

/**
 * App-level fatal status flags decided at boot. Distinct from the per-tenant
 * `experienceStore` (which tracks domain-config load state): this store records
 * whether the *configured app/tenant itself* exists.
 *
 * `notFound` is set only on a DEFINITIVE not-found — `POST /resolve-domain`
 * returning 404 (no tenant for the configured domain). Transient failures
 * (offline, timeout, Core 5xx) must NOT set it, so a temporary outage never
 * hard-blocks the app. When true, the root `<App>` renders a full-screen block
 * instead of the normal shell.
 */
interface AppStatusState {
  notFound: boolean;
  setNotFound: (notFound: boolean) => void;
}

export const useAppStatusStore = create<AppStatusState>((set) => ({
  notFound: false,
  setNotFound(notFound) {
    set({ notFound });
  },
}));
